module.exports = __webpack_public_path__ + "public/Icons/17Failedorders.svg?052a9f6f";